module.exports = __webpack_public_path__ + "static/img/prize4.212449b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/prize4.png
// module id = yyqc
// module chunks = 1